import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { fetchPage } from '../api/public'
import { useCrtPageTitle } from '../hooks/useCrtPageTitle'
import { usePageMeta } from '../hooks/usePageMeta'
import { schemaBreadcrumb, schemaGraph, schemaWebPage } from '../lib/schema-org'

export function LegalPage({
  slug,
  titleFallback,
}: {
  slug: string
  titleFallback: string
}) {
  const q = useQuery({
    queryKey: ['page', slug],
    queryFn: () => fetchPage(slug),
    retry: false,
  })

  const title = q.data?.title || titleFallback
  useCrtPageTitle(title)

  const path = slug === 'datenschutzerklaerung' ? '/datenschutz' : `/${slug}`
  const jsonLd = useMemo(() => {
    const crumbs = schemaBreadcrumb(
      [
        { name: 'Home', path: '/' },
        { name: title, path },
      ],
      path,
    )
    return schemaGraph(
      crumbs,
      schemaWebPage({
        path,
        name: title,
        breadcrumb: crumbs,
        pageType: 'WebPage',
      }),
    )
  }, [path, title, slug])

  usePageMeta({
    title,
    canonical: path,
    jsonLd,
  })

  return (
    <section id="legal" className="section legal-prose" style={{ paddingBottom: 'var(--sp-16)', paddingTop: 'var(--sp-6)' }}>
      <div className="kicker crt">
        ↳ /{slug === 'datenschutzerklaerung' ? 'datenschutz' : slug}
      </div>
      <h1 className="display h2" style={{ marginTop: 14 }}>
        {title}
      </h1>
      {q.data?.bodyHtml ? (
        <div className="rich-text rich-text--paper" style={{ marginTop: 32 }} dangerouslySetInnerHTML={{ __html: q.data.bodyHtml }} />
      ) : (
        !q.isLoading && <p className="muted">Seite noch nicht synchronisiert.</p>
      )}
    </section>
  )
}
